export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["للوصول إلى جميع ميزات حسابك، يرجى إكمال عملية التحقق السريعة من الهوية. يساعدنا ذلك في الحفاظ على أمان حسابك والامتثال للوائح المالية."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحقق الآن"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لاحقاً"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحقق من هويتك"])}
}